import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import Box from '@mui/material/Box';

import { approxAzure, darkGrey, greyBackground, trackerCardZIndex } from '~/styles';

interface Props {
  text: string;
  achievedGoals?: number;
  totalGoals?: number;
  barColor?: string;
  barText?: string;
  barCount?: number;
  weeklyActivity?: number;
  hoursLogged?: number;
}

const ScoreBox = styled(({ ...props }) => <Box {...props} />)<Omit<Props, 'text'>>`
  position: relative;
  color: #fff;
  font-size: 10px;
  overflow: hidden;
  border-radius: 4px;
  padding: 10px 12px;
  text-align: center;
  height: 100%;
`;

export const TrackerCard: React.FC<PropsWithChildren<Props>> = ({
  text,
  achievedGoals,
  barColor,
  barText = '',
  barCount = 0,
  totalGoals,
  weeklyActivity,
  hoursLogged,
}) => {
  let isComplete = false;
  let content = '';
  if (achievedGoals !== undefined && totalGoals !== undefined) {
    isComplete = totalGoals !== 0 && achievedGoals >= totalGoals;
    content = `${Math.floor(achievedGoals)} / ${Math.floor(totalGoals)}`;
  } else if (weeklyActivity) {
    content = Math.floor(weeklyActivity).toString();
  } else if (hoursLogged) {
    content = Math.floor(hoursLogged).toString();
  } else {
    content = '0';
  }

  const testidText = text.replace(/\s+/g, '_').toLowerCase();

  return (
    <ScoreBox bgcolor={isComplete ? barColor : approxAzure} position="relative">
      <Box zIndex={trackerCardZIndex} position="relative">
        <Box
          data-testid={`${testidText}-tracker-card-content`}
          component="h3"
          fontSize={20}
          textAlign="center"
          fontWeight="bold"
          color={isComplete ? 'white' : darkGrey}
          mb={0.4}
        >
          {content}
        </Box>
        <Box
          component="h6"
          fontSize={12}
          textAlign="center"
          fontWeight="normal"
          color={isComplete ? 'white' : darkGrey}
          mb="12px"
          style={{ textTransform: 'capitalize' }}
        >
          {text}
        </Box>
      </Box>
      <Box
        bgcolor={barColor ? barColor : greyBackground}
        fontSize="10px"
        lineHeight="12px"
        padding="2px 0"
        color="white"
        textAlign="center"
        position="absolute"
        width="100%"
        bottom="0"
        left="0"
        minHeight="8px"
      >
        {barText && (
          <Box component="p" m={0}>
            {barText}: {Math.floor(barCount)}
          </Box>
        )}
      </Box>
    </ScoreBox>
  );
};
